import { Action as CMSAction } from '../actions/cms';

const defaultState = {
  isFetching: false,
  pages: {},
  urls: [],
};

export default function cms(state = defaultState, action = {}) {
  switch (action.type) {
    case CMSAction.Page.PagePending:
      return {
        ...state,
        isFetching: true,
      };

    case CMSAction.Page.PageFailed:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case CMSAction.Page.PageCompleted:
      return {
        ...state,
        isFetching: false,
        pages: {
          ...state.pages,
          [action.payload.page.url]: action.payload.page,
        },
      };

    default:
      return state;
  }
}
